export default {
    /* GET_DAILY_REPORTS
    ---------------------------------------------------------------
    */
    GET_REPORTS_SHIFT_SUMMARIES_REQUEST: state => {
        state.reportsShiftSummariesLoading = true
    },
    GET_REPORTS_SHIFT_SUMMARIES_SUCCESS: (state, data) => {
        state.reportsShiftSummaries = data.results
        state.reportsShiftSummariesLoading = false
    },
    GET_REPORTS_SHIFT_SUMMARIES_FAILURE: state => {
        state.reportsShiftSummariesLoading = false
    },
    GET_SHIPMENTS_REPORTS_SHIFT_SUMMARIES_REQUEST: state => {
        state.reportsShiftSummariesLoading = true
    },
    GET_SHIPMENTS_REPORTS_SHIFT_SUMMARIES_SUCCESS: (state, data) => {
        state.reportsShiftSummaries = data.results
        state.reportsShiftSummariesLoading = false
    },
    GET_SHIPMENTS_REPORTS_SHIFT_SUMMARIES_FAILURE: state => {
        state.reportsShiftSummariesLoading = false
    },
    GET_REPORT_SHIFT_SUMMARY_STATUSES: (state, data) => {
        state.reportShiftSummaryStatuses = data.results
    },

    GET_SHIPMENTS_REPORT_SHIFT_SUMMARY_STATUSES: (state, data) => {
        state.reportShiftSummaryStatuses = data.results
    },

    GET_CODE_COMPLIANCE_PATTERNS_SUCCESS: (state, data) => {
        state.codeCompliancesList = data.results
    },

    GET_REPORT_SHIFT_SUMMARY_GROUPS: (state, data) => {
        state.reportShiftSummaryGroups = data.results
    },

    /* GET_DAILY_REPORTS
    ---------------------------------------------------------------
    */
    GET_DETAILED_REPORTS_REQUEST: state => {
        state.detailedReportsLoading = true
    },
    GET_DETAILED_REPORTS_SUCCESS: (state, data) => {
        state.detailedReports = data.results
        state.detailedReportsLoading = false
    },
    GET_DETAILED_REPORTS_FAILURE: state => {
        state.detailedReportsLoading = false
    },
    /* GET_SIMPLE_REPORTS
    ---------------------------------------------------------------
    */
    SET_FROM_MACHINE_DASHBOARD_REDIRECT: (state, boolean) => {
        state.redirectionFromMachinesDashboard = boolean
    },
    /* GET_USER_REPORTS
    ---------------------------------------------------------------
    */
    GET_USER_DETAILED_REPORTS_REQUEST: state => {
        state.userDetailedReportsLoading = true
    },
    GET_USER_DETAILED_REPORTS_SUCCESS: (state, data) => {
        state.userDetailedReports = data.results
        state.userDetailedReportsLoading = false
    },
    GET_USER_DETAILED_REPORTS_FAILURE: state => {
        state.userDetailedReportsLoading = false
    },

    /* GET_SHIPMENTS_REPORTS
    ---------------------------------------------------------------
    */
    GET_DETAILED_SHIPMENTS_REPORTS_REQUEST: state => {
        state.detailedShipmentsReportsLoading = true
    },
    GET_DETAILED_SHIPMENTS_REPORTS_SUCCESS: (state, data) => {
        state.detailedShipmentsReports = data.results
        state.detailedShipmentsReportsLoading = false
    },
    GET_DETAILED_SHIPMENTS_REPORTS_FAILURE: state => {
        state.detailedShipmentsReportsLoading = false
    },
    /* GET_MACHINES
    ---------------------------------------------------------------
    */
    GET_MACHINES_REQUEST: state => {
        state.machinesLoading = true
    },
    GET_MACHINES_SUCCESS: (state, data) => {
        state.machines = data.results
        state.machinesLoading = false
    },
    GET_MACHINES_FAILURE: state => {
        state.machinesLoading = false
    },

    /* GET_STATUS_NAMES
    ---------------------------------------------------------------
    */
    GET_STATUS_NAMES_SUCCESS: (state, data) => {
        state.statusNames = data.results
    },

    /* GET_OBJECT_TYPE_NAMES
    ---------------------------------------------------------------
    */
    GET_OBJECT_TYPE_NAMES_SUCCESS: (state, data) => {
        state.taskNames = data.results
    },

    SET_DETAILED_REPORTS_FILTERS: (state, filters) => {
        state.detailedReportsFilters = filters
    },
    CLEAR_DETAILED_REPORTS_FILTERS: state => {
        state.detailedReportsFilters = state.setInitialDetailedReportsFilters()
    },
    SET_REPORTS_SHIFT_SUMMARIES_FILTERS: (state, filters) => {
        state.reportsShiftSummariesFilters = filters
    },
    CLEAR_REPORTS_SHIFT_SUMMARIES_FILTERS: state => {
        state.reportsShiftSummariesFilters = state.setInitialReportsShiftSummariesFilters()
    },
    SET_USER_REPORTS_SHIFT_SUMMARIES_FILTERS: (state, filters) => {
        state.userReportsShiftSummariesFilters = filters
    },
    CLEAR_USER_REPORTS_SHIFT_SUMMARIES_FILTERS: state => {
        state.userReportsShiftSummariesFilters = state.setInitialUserReportsShiftSummariesFilters()
    },

    SET_DETAILED_SHIPMENTS_REPORTS_FILTERS: (state, filters) => {
        state.detailedShipmentsReportsFilters = filters
    },
    CLEAR_DETAILED_SHIPMENTS_REPORTS_FILTERS: state => {
        state.detailedShipmentsReportsFilters = state.setInitialDetailedShipmentsReportsFilters()
    },
    CLEAR_REPORTS_SHIFT_SUMMARIES: state => {
        state.reportsShiftSummaries = []
    },
    CLEAR_CODE_COMPLIANCES_LIST_FILTERS: state => {
        state.codeCompliancesListFilters = state.setInitialCodeCompliancesListFilters()
    },
}